/**
 * @fileoverview
 * This file contains the custom dimensions for the jobiqo analytics.
 * 1 ) Job application_url
 */

import { Job, OrganizationProfile } from '~/jobiqo/types/types';
import { DIMENSIONS, Dimensions } from '~/jobiqo/lib/analytics';
import { User } from '~/jobiqo/models/user';
import { useApplicationLink } from '~/jobiqo/components/Job/Detail/hooks/useApplicationLink';

/**
 * Returns the custom dimensions for a given job.
 *
 * Can be used to add custom dimensions to the analytics event for a job.
 *
 * @param {Job} job
 *  The job to return dimensions for.
 * @param {User} user
 *  The current user.
 * @returns {Dimensions}
 *  The custom dimensions object for this job.
 */
export const getCustomJobDimensions = (
  job: Job,
  user: User | null = null,
): Dimensions => {
  // Client wants to have application url of the job.
  let host = typeof window !== 'undefined' ? window?.location?.origin : '';

  let application_url =
    job.applicationWorkflow === 'internal'
      ? host + useApplicationLink(job)
      : useApplicationLink(job);

  return {
    [DIMENSIONS.application_url]: application_url,
    [DIMENSIONS.job_city]: job.location?.[0]?.locality ?? '',
    [DIMENSIONS.job_country]: job.location?.[0]?.countryCode ?? '',
    [DIMENSIONS.job_state]: job.location?.[0]?.administrativeArea ?? '',
  };
};

/**
 * Returns the custom dimensions for a given organization profile.
 *
 * Can be used to add custom dimensions to the analytics event for an organization profile.
 *
 * @param {OrganizationProfile} organizationProfile
 *  The organization profile to return dimensions for.
 * @returns {Dimensions}
 *  The custom dimensions object for this organization profile.
 */
export const getCustomOrganizationProfileDimensions = (
  organizationProfile: OrganizationProfile,
): Dimensions => {
  return {};
};
